<partial-header></partial-header>
<section class="page-home"> 
  <modulo posicao="banner-slider"></modulo>
  <modulo posicao="produto-destaque-semana"></modulo>  
  <modulo posicao="modulo-lista"></modulo>
  <modulo posicao="produto-categorias"></modulo>
  <modulo posicao="depoimentos"></modulo>
  <modulo posicao="newsletter"></modulo>       
  <to-up></to-up>  
</section>  
<menu-mobile></menu-mobile> 
<partial-footer></partial-footer>

 



